import { optionsFunction } from "./_config";
import axios from "axios";

export const getAdyenSession = (payload) =>
  axios
    .post(
      `/api/payment/adyen/session`,
      {
        locale: payload.locale,
        offer_package_id: payload.offerId,
        return_url: payload.returnUrl,
      },
      optionsFunction()
    )
    .then((res) => res.data.data);

export const createPaypalOrder = async (id) => {
  try {
    const res = await axios.post(
      "/api/payment/paypal/create",
      { offer_package_id: id },
      optionsFunction()
    );
    return res;
  } catch (err) {
    console.error("API error in createPaypalOrder:", err);
    throw err;
  }
};

export const fetchPaypalPaymentCapture = (transactionId, orderId) =>
  axios
    .post(
      "/api/payment/paypal/capture",
      {
        transaction_reference: transactionId,
        order_id: orderId,
      },
      optionsFunction()
    )
    .then((res) => {
      return res;
    });
/**
 * @deprecated This offer system is being rebuilt. Do not use this method.
 */
export const fetchAllPaymentOffers = () =>
  axios
    .post(`/api/payment/offers/list`, {}, optionsFunction())
    .then((res) => res.data.data);

/**
 * @deprecated This offer system is being rebuilt. Do not use this method.
 */
export const fetchPaymentOffersByOfferType = (type) =>
  axios
    .post(
      `/api/payment/offers/getByType`,
      { offer_type: type },
      optionsFunction()
    )
    .then((res) => res.data.data);

/**
 * @deprecated This offer system is being rebuilt. Do not use this method.
 */
export const fetchPaymentOffersByOfferId = (id) =>
  axios
    .post(`/api/payment/offers/getById`, { offer_id: id }, optionsFunction())
    .then((res) => res.data.data);

/**
 * @deprecated This offer system is being rebuilt. Do not use this method.
 */
export const fetchPaymentOffersLobby = () =>
  axios
    .post(`/api/payment/offers/overview`, {}, optionsFunction())
    .then((res) => res.data.data);

/**
 * @deprecated This offer system is being rebuilt. Do not use this method.
 */
export const fetchPaymentOffersRandom = () =>
  axios
    .post(`/api/payment/offers/random`, {}, optionsFunction())
    .then((res) => res.data.data);
